export default __webpack_public_path__ + "static/tanecni-kurzy-1-b4ccde6b8fc45fc4ce1e514d7d165906.jpg";